import { IconButton, Stack, Tab, Tabs } from '@mui/material';
import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Badge from './Badge';
import { Icon } from '../core/icon';
import { HexMapResourceTypeID } from '../core/resourceTypes/hexmap';
import HexMapEditor from '../features/hexmap/HexMapEditor';
import { css, cx } from '@emotion/css';
import { COLOR_BG_PRIMARY, COLOR_BORDER_PRIMARY, SPACING_SMALL } from './theme';
import { renderIcon } from './renderIcon';
import Flex from './layouts/Flex';
import AboutView from './AboutView';
import EmptyEditorsView from './EmptyEditorsView';
import { useServices } from './ServiceProvider';
import { ErrorBoundary } from 'react-error-boundary';
const editorsPaneStyle = css `
  background-color: ${COLOR_BG_PRIMARY};
  flex-grow: 1;
`;
const editorTabsStyle = css `
  border-bottom: 1px solid ${COLOR_BORDER_PRIMARY};
`;
const editorStyle = css `
  flex-grow: 1;
`;
const editorHandlers = [
    {
        editor: ({ className, resource, onChange }) => React.createElement(HexMapEditor, { className: className, resource: resource, onChange: onChange }),
        condition: (editorTab) => editorTab.resource?.typeID === HexMapResourceTypeID,
        title: (editorTab) => editorTab.resource?.name,
        icon: (editorTab) => editorTab.resource?.type.icon,
    },
    {
        editor: AboutView,
        condition: ({ viewerID }) => viewerID === 'core:about',
        title: 'About',
        icon: Icon.INFO
    },
];
const getEditorHandlerForTab = (editorTab) => (editorTab ? editorHandlers.find(({ condition }) => condition(editorTab)) : undefined);
const EditorTabs = ({ editorTabs, focusedTab }) => {
    const { EditorsService } = useServices();
    const dispatch = useDispatch();
    return (React.createElement(Tabs, { id: "editor-tabs", className: editorTabsStyle, value: focusedTab?.id, onChange: (_, value) => dispatch(EditorsService.actions.focusEditorTab(value)) }, editorTabs
        .map(editorTab => ({ editorTab, handler: getEditorHandlerForTab(editorTab) }))
        .map(({ editorTab, handler }) => (React.createElement(Tab, { key: editorTab.id, "resource-type-id": editorTab.resource?.typeID, "resource-id": editorTab.resource?.id, "viewer-id": editorTab.viewerID, value: editorTab.id, label: React.createElement(Flex, { alignItems: 'center', justifyContent: 'space-between', gap: SPACING_SMALL },
            React.createElement(Badge, { icon: typeof (handler?.icon) === 'function' ? handler.icon(editorTab) : handler?.icon, label: typeof (handler?.title) === 'function' ? handler.title(editorTab) : handler?.title }),
            React.createElement(IconButton, { onClick: (e) => {
                    dispatch(EditorsService.actions.closeEditorTab(editorTab.id));
                    e.preventDefault();
                    e.stopPropagation();
                } }, renderIcon(Icon.CLOSE))) })))));
};
const EditorsPane = ({ className }) => {
    const dispatch = useDispatch();
    const { ChangeService, EditorsService } = useServices();
    // const selectedResourceID = useSelector(selectors.getSelectedResourceID);
    // const selectedResource = useSelector(selectors.getSelectedResource);
    const editorTabs = useSelector(EditorsService.getTabs);
    const focusedTab = useSelector(EditorsService.getFocusedTab);
    const editorTabsExist = Boolean(editorTabs.length);
    const { editor: Editor } = getEditorHandlerForTab(focusedTab) || {};
    return (React.createElement(Flex, { direction: "column", className: cx(className, editorsPaneStyle) }, editorTabsExist ? (React.createElement(Fragment, null,
        React.createElement(EditorTabs, { editorTabs: editorTabs, focusedTab: focusedTab }),
        focusedTab && Editor && (React.createElement(Stack, { id: "editor-wrapper", flexGrow: "1", "resource-type-id": focusedTab.resource?.typeID, "resource-id": focusedTab.resource?.id, "viewer-id": focusedTab.viewerID },
            React.createElement(ErrorBoundary, { fallback: null },
                React.createElement(Editor, { className: editorStyle, resource: { ...focusedTab.resource }, onChange: (change) => {
                        dispatch(ChangeService.commit(change));
                    } })))))) : React.createElement(EmptyEditorsView, null)));
};
export default EditorsPane;
//# sourceMappingURL=EditorsPane.js.map